/* ============================================================
   oz-glass — comportements du storefront glass (Shopify)

   Reprise de glass.js du site de test, mais branchée sur du réel :
   les variantes, le panier et les formulaires passent par Shopify.
   Tout est défensif : si un élément manque, on ne casse rien.

   Les prix sont pré-formatés côté Liquid et transportés dans le JSON
   des variantes — inutile de reproduire money_format en JavaScript.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }
  function each(root, sel, fn) {
    Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn);
  }
  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- Verrou de defilement ----------
     Ordinateur : `body { overflow: hidden }` suffit (la barre de defilement
     qui disparait est compensee par --oz-sb, voir openCart).

     Ecran tactile : on ne touche PAS a la page. L ancienne parade figeait
     le body en `position: fixed` (parce qu iOS Safari ignore
     `overflow: hidden`). Or rendre la page NON DEFILABLE — par overflow
     comme par position: fixed — fait REAPPARAITRE la barre d adresse de
     Chrome Android : il la remontre des que la page ne peut plus defiler.
     La zone visible perd d un coup une soixantaine de pixels,
     visualViewport change, et tout ce qui est cale dessus — le tiroir —
     saute, pile pendant l ouverture. Sans compter le retour a la position
     de depart a la fermeture, deja rafistole une fois.

     On bloque donc le GESTE et non la page : un `touchmove` non passif
     annule tout defilement, sauf a l interieur d une zone defilante du
     calque ouvert (liste d articles, menu) qui peut encore defiler dans le
     sens du doigt. Rien ne change dans la mise en page : rien ne bouge. */
  var verrouActif = false;
  var verrouTactile = false;
  var toucheY = 0;
  function tactile() {
    return window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  }
  // Les zones qui gardent le droit de defiler sous verrou. L attribut est
  // le contrat ; les deux classes sont le repli pour le markup existant.
  var ZONES = '[data-oz-scroll], .oz-cart__items, .np__scroll';
  function zoneDefilante(el) {
    while (el && el !== document.body) {
      if (el.matches && el.matches(ZONES)) return el;
      el = el.parentNode;
    }
    return null;
  }
  // dy > 0 : le doigt descend, on veut voir le HAUT. La zone prend le geste
  // si elle a encore de quoi defiler dans ce sens ; sinon il irait a la page.
  function zonePrend(zone, dy) {
    if (!zone || zone.scrollHeight <= zone.clientHeight + 1) return false;
    if (dy > 0) return zone.scrollTop > 0;
    if (dy < 0) return zone.scrollTop + zone.clientHeight < zone.scrollHeight - 1;
    return true;
  }
  function surToucheDebut(e) {
    toucheY = e.touches[0].clientY;
  }
  function surToucheMouv(e) {
    if (!e.cancelable || e.touches.length > 1) return; // deja en cours, ou pincement
    var dy = e.touches[0].clientY - toucheY;
    if (!zonePrend(zoneDefilante(e.target), dy)) e.preventDefault();
  }
  function verrouiller() {
    if (verrouActif) return;
    verrouActif = true;
    if (tactile()) {
      verrouTactile = true;
      document.addEventListener('touchstart', surToucheDebut, { passive: true });
      document.addEventListener('touchmove', surToucheMouv, { passive: false });
      return;
    }
    document.body.style.overflow = 'hidden';
  }
  function deverrouiller() {
    if (!verrouActif) return;
    verrouActif = false;
    if (verrouTactile) {
      verrouTactile = false;
      document.removeEventListener('touchstart', surToucheDebut);
      document.removeEventListener('touchmove', surToucheMouv);
      return;
    }
    document.body.style.overflow = '';
  }

  /* ---------- 1. Marquees : 2 copies exactes pour boucler sans saut ---------- */
  function initMarquees(root) {
    each(root, '.mqrow', function (row) {
      if (!once(row, 'ozDup')) return;
      row.innerHTML = row.innerHTML + row.innerHTML;
      row.setAttribute('aria-hidden', 'false');
    });
  }

  /* ---------- 2. Barres de stats qui se remplissent au scroll ---------- */
  function initGrow(root) {
    var bars = (root || document).querySelectorAll('[data-grow]');
    if (!bars.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(bars, function (b) { b.style.width = b.getAttribute('data-grow'); });
      return;
    }
    // On observe le parent : une barre à width:0 a une aire nulle et ne
    // franchirait jamais le seuil d'intersection.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // Un saut de défilement (molette rapide, ancre, restauration de
        // position) peut franchir l'élément sans qu'il atteigne jamais le
        // seuil : on déclenche donc aussi quand il est DÉJÀ passé au-dessus,
        // sinon la barre reste bloquée à width:0.
        var alreadyPassed = e.boundingClientRect.top < 0;
        if (!e.isIntersecting && !alreadyPassed) return;
        each(e.target, '[data-grow]', function (b) { b.style.width = b.getAttribute('data-grow'); });
        io.unobserve(e.target);
      });
    }, { threshold: 0.15 });
    Array.prototype.forEach.call(bars, function (b) {
      if (b.parentElement && once(b, 'ozGrow')) io.observe(b.parentElement);
    });
  }

  /* ---------- 3. Galerie : vignette -> visuel principal ---------- */
  function initGallery(root) {
    each(root, '[data-gallery]', function (gal) {
      if (!once(gal, 'ozGal')) return;
      var dots = gal.querySelectorAll('.dots i');
      each(gal, '.thumb', function (thumb, i) {
        thumb.addEventListener('click', function () {
          each(gal, '.thumb', function (t) { t.classList.remove('on'); });
          thumb.classList.add('on');
          Array.prototype.forEach.call(dots, function (d, j) { d.classList.toggle('on', i === j); });
          swapMain(gal, thumb.getAttribute('data-src'), thumb.getAttribute('data-alt'));
        });
      });
    });
  }

  function swapMain(scope, src, alt) {
    if (!scope || !src) return;
    var main = scope.querySelector('[data-oz-main]');
    if (!main) return;
    var img = main.querySelector('img');
    if (!img) return;
    img.src = src;
    img.removeAttribute('srcset');
    if (alt) img.alt = alt;
  }

  // Appelée quand une variante change d'image : on aligne aussi la vignette active.
  function showVariantImage(scope, src) {
    if (!src) return;
    var gal = scope.querySelector('[data-gallery]') || scope;
    swapMain(gal, src);
    each(gal, '.thumb', function (t) {
      t.classList.toggle('on', t.getAttribute('data-src') === src);
    });
  }

  /* ---------- 4. Sélecteurs de quantité (input réel) ---------- */
  function initQty(root) {
    each(root, '[data-qty]', function (box) {
      if (!once(box, 'ozQty')) return;
      var input = box.querySelector('input');
      box.addEventListener('click', function (e) {
        var step = e.target.closest('[data-step]');
        if (!step || !input) return;
        e.preventDefault();
        var n = parseInt(input.value, 10);
        if (isNaN(n)) n = 1;
        input.value = Math.max(1, n + parseInt(step.getAttribute('data-step'), 10));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- 5. Groupes d'options -> vraie variante Shopify ---------- */
  function initVariants(root) {
    each(root, '[data-oz-product]', function (scope) {
      if (!once(scope, 'ozVar')) return;
      var tag = scope.querySelector('[data-oz-variants]');
      if (!tag) return;
      var variants;
      try { variants = JSON.parse(tag.textContent); } catch (err) { return; }
      if (!variants || !variants.length) return;

      // Prix, prix barré et état de stock peuvent apparaître plusieurs fois
      // (encart d'achat + barre collante) : on met à jour toutes les occurrences.
      var idInputs = scope.querySelectorAll('[data-oz-variant-id]');

      function selected() {
        var vals = [];
        each(scope, '[data-oz-optgroup]', function (g) {
          var on = g.querySelector('[data-oz-option].on');
          vals.push(on ? on.getAttribute('data-value') : null);
        });
        return vals;
      }

      function match(vals) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < vals.length; j++) {
            if (vals[j] !== null && v.options[j] !== vals[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function apply() {
        var v = match(selected());
        if (!v) return;
        Array.prototype.forEach.call(idInputs, function (i) { i.value = v.id; });
        each(scope, '[data-oz-price]', function (el) { el.textContent = v.price; });
        each(scope, '[data-oz-compare]', function (el) {
          el.textContent = v.compare || '';
          el.hidden = !v.compare;
        });
        each(scope, '[data-oz-stock]', function (el) {
          var txt = v.available ? el.getAttribute('data-in') : el.getAttribute('data-out');
          // La ligne porte une icône SVG à côté du texte : écrire dans
          // textContent effacerait l'icône. On ne remplace que le libellé
          // quand il est isolé, sinon on garde l'ancien comportement.
          var lbl = el.querySelector('[data-oz-stock-label]');
          if (lbl) { lbl.textContent = txt; } else { el.textContent = txt; }
        });
        each(scope, '[data-oz-atc]', function (b) {
          b.disabled = !v.available;
          var lbl = b.querySelector('[data-oz-atc-label]');
          if (lbl) {
            lbl.textContent = v.available
              ? b.getAttribute('data-label-in')
              : b.getAttribute('data-label-out');
          }
        });
        if (v.img) showVariantImage(scope, v.img);
        // L'URL suit la variante, comme sur un thème standard.
        if (window.history && window.history.replaceState && v.id) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', u.toString());
          } catch (err) { /* URL indisponible : sans importance */ }
        }
      }

      each(scope, '[data-oz-optgroup]', function (group) {
        var isPill = group.getAttribute('data-oz-optgroup') === 'pill';
        group.addEventListener('click', function (e) {
          var item = e.target.closest('[data-oz-option]');
          if (!item || !group.contains(item)) return;
          e.preventDefault();
          each(group, '[data-oz-option]', function (c) {
            c.classList.remove('on');
            // Une pill active passe de verre (.gb) à blanc (.wb).
            if (isPill && c !== item) { c.classList.remove('wb'); c.classList.add('gb'); }
          });
          item.classList.add('on');
          if (isPill) { item.classList.remove('gb'); item.classList.add('wb'); }
          apply();
        });
      });

      apply();
    });
  }

  /* ---------- 6. Ajout au panier ---------- */
  function refreshCart() {
    return fetch(routeRoot() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        each(document, '[data-oz-cart-count]', function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        // On prévient Dawn pour que son tiroir se resynchronise.
        document.dispatchEvent(new CustomEvent('oz:cart:updated', { detail: cart }));
      })
      .catch(function () { /* le compteur restera à sa valeur serveur */ });
  }

  function initQuickAdd(root) {
    each(root, '[data-oz-quickadd]', function (btn) {
      if (!once(btn, 'ozQa')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-variant-id');
        if (!id || btn.dataset.busy) return;
        btn.dataset.busy = '1';
        var old = btn.textContent;
        fetch(routeRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            btn.textContent = '✓';
            btn.classList.add('added');
            refreshCart();
            // le tiroir s'ouvre sur le panier à jour : on attend le rendu
            return refreshCartDrawer().then(openCart);
          })
          .catch(function () { btn.textContent = '!'; })
          .then(function () {
            setTimeout(function () {
              btn.textContent = old;
              btn.classList.remove('added');
              delete btn.dataset.busy;
            }, 1400);
          });
      });
    });
  }

  // Le formulaire produit part en AJAX pour ne pas quitter la page.
  function initAtcForms(root) {
    each(root, 'form[data-oz-atc-form]', function (form) {
      if (!once(form, 'ozAtcForm')) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btns = form.querySelectorAll('[data-oz-atc]');
        Array.prototype.forEach.call(btns, function (b) { b.disabled = true; });
        fetch(routeRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            refreshCart();
            refreshCartDrawer().then(openCart);
            each(form, '[data-oz-atc-label]', function (l) {
              var b = l.closest('[data-oz-atc]');
              l.textContent = (b && b.getAttribute('data-label-done')) || 'ajouté';
            });
            setTimeout(function () {
              each(form, '[data-oz-atc-label]', function (l) {
                var b = l.closest('[data-oz-atc]');
                if (b) l.textContent = b.getAttribute('data-label-in');
              });
            }, 1600);
          })
          .catch(function () { /* Shopify affichera l'erreur au checkout */ })
          .then(function () {
            Array.prototype.forEach.call(btns, function (b) { b.disabled = false; });
          });
      });
    });
  }

  /* ---------- 7. Navigation mobile ---------- */
  function initNav(root) {
    var burger = (root || document).querySelector('.nav__burger');
    var panel = document.querySelector('.navpanel');
    if (!panel || !burger || !once(burger, 'ozNav')) return;
    // Le voile est le frere du panneau (couche 50) ; la croix est dedans.
    var veil = panel.parentNode.querySelector('.navpanel__veil');
    var closeBtn = panel.querySelector('.navpanel__close');
    burger.setAttribute('aria-expanded', 'false');
    function toggle(open) {
      if (open === (panel.dataset.open === 'true')) return;
      panel.dataset.open = open ? 'true' : 'false';
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) verrouiller(); else deverrouiller();
      // Le clavier suit : la croix a l ouverture, le burger a la fermeture
      // (seulement si le focus etait dans le panneau — pas apres un clic
      // sur un lien, la page va changer).
      if (open) {
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      } else if (document.activeElement && panel.contains(document.activeElement)) {
        burger.focus({ preventScroll: true });
      }
    }
    burger.addEventListener('click', function () { toggle(true); });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('.navpanel__close') || e.target.closest('a')) toggle(false);
    });
    if (veil) veil.addEventListener('click', function () { toggle(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggle(false); });
  }

  /* ---------- 8. Accordéons exclusifs ---------- */
  function initAcc(root) {
    each(root, '[data-oz-acc]', function (wrap) {
      if (!once(wrap, 'ozAcc')) return;
      each(wrap, 'details', function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          each(wrap, 'details', function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- 9. En-tête collant : bascule de l'état « défilé » ---------- */
  function initStickyHeader() {
    var group = document.querySelector('.shopify-section-group-header-group');
    if (!group || !once(group, 'ozSticky')) return;
    var state = null;
    function update() {
      var next = window.scrollY > 40;
      // on ne touche au DOM qu'au CHANGEMENT d'état : sinon on écrirait
      // une classe à chaque frame de défilement pour rien
      if (next === state) return;
      state = next;
      group.classList.toggle('oz-scrolled', next);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- 10. Tiroir panier ---------- */
  var cartRoot;

  function cartEl() {
    if (!cartRoot) cartRoot = document.querySelector('[data-oz-cart]');
    return cartRoot;
  }

  // `visibility` est pilotée ici et non par une transition CSS : sur cette
  // propriété discrète, `transition: visibility 0s linear .44s` ne bascule
  // pas de façon fiable — mesuré, le panneau restait « visible » 2,4 s après
  // la fermeture, donc toujours présent dans l'arbre d'accessibilité.
  var cartHideTimer;
  // Doit couvrir la SORTIE (320 ms), pas l entree : c est apres la sortie
  // que le panneau est masque. Un chiffre trop grand laisse un panneau
  // invisible mais encore present dans l arbre d accessibilite.
  var CART_SLIDE_MS = 360; // durée du transform (.70s) + marge

  // Cale le tiroir sur la fenetre VISIBLE, pas sur la fenetre theorique.
  //
  // Sur telephone, un element `position: fixed` est ancre au LAYOUT
  // viewport, et les navigateurs mobiles ne le redimensionnent PAS quand
  // la barre d adresse apparait : ils ne redimensionnent que le VISUAL
  // viewport. Consequence, `inset: 0` deborde par le bas de la hauteur de
  // la barre — et un panneau colle a `bottom: 0` se retrouve dessous.
  // Quand la barre glisse, la zone visible change et le panneau semble
  // monter puis redescendre. Ce n est pas l animation : c est l ancrage.
  //
  // On recale donc la racine sur `visualViewport`, qui decrit exactement
  // ce que l oeil voit. Sur ordinateur, visualViewport vaut la fenetre :
  // le calcul est neutre.
  function caleTiroir() {
    var vv = window.visualViewport;
    var root = cartEl();
    if (!vv || !root) return;
    root.style.top = vv.offsetTop + 'px';
    // `top` + `bottom` + `height` sur-contraint la boite : `bottom` doit
    // rendre la main, sinon la hauteur posee ici est ignoree.
    root.style.bottom = 'auto';
    root.style.height = vv.height + 'px';
  }

  function decaleTiroir() {
    var root = cartEl();
    if (!root) return;
    root.style.top = '';
    root.style.bottom = '';
    root.style.height = '';
  }

  // La barre d adresse peut bouger pendant que le tiroir est ouvert.
  // On suit, au lieu de laisser le panneau passer dessous.
  if (window.visualViewport) {
    var suivre = function () {
      var root = cartEl();
      if (root && root.classList.contains('is-open')) caleTiroir();
    };
    window.visualViewport.addEventListener('resize', suivre);
    window.visualViewport.addEventListener('scroll', suivre);
  }

  function openCart() {
    var root = cartEl();
    if (!root) return;
    clearTimeout(cartHideTimer);
    root.style.visibility = 'visible';
    // Le glissement précédent a pu laisser une progression : on repart de zéro.
    root.style.setProperty('--oz-cart-progress', 0);
    // On FIGE la hauteur du panneau pendant toute la montee.
    //
    // `translateY(100%)` se mesure sur la hauteur de l element lui-meme, et
    // le panneau est ancre en bas : si sa hauteur change en cours de route,
    // son bord haut bouge — le panneau monte, puis redescend. Figer la
    // hauteur rend l animation insensible a tout ce qui pourrait modifier le
    // contenu pendant ce temps (rafraichissement, image, police).
    var pan = root.querySelector('.oz-cart__panel');
    if (pan) {
      // La fermeture pose une duree EN LIGNE, purgee par un minuteur. Une
      // reouverture avant la fin de ce minuteur heriterait de la vitesse de
      // sortie : on la retire tout de suite.
      pan.style.transitionDuration = '';
      pan.style.height = pan.getBoundingClientRect().height + 'px';
    }

    // Le calage se fait AVANT que la classe arrive : la racine a deja sa
    // bonne taille quand la transition demarre, donc rien ne bouge en
    // cours de route.
    caleTiroir();

    root.classList.add('is-open');

    // Bloquer le defilement retire la barre : la fenetre s elargit et tout
    // ce qui est en position fixe se decale, pile au demarrage de
    // l animation. On mesure la barre et on la compense.
    var barre = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--oz-sb', barre + 'px');
    document.body.style.paddingRight = barre + 'px';
    verrouiller();
    var panel = root.querySelector('.oz-cart__panel');
    // preventScroll : la page est defilable sous le tiroir (verrou tactile
    // par geste), et un focus() ordinaire peut la faire defiler pour
    // « montrer » un panneau qui est de toute facon en position fixe.
    if (panel) panel.focus({ preventScroll: true });
  }

  function closeCart(ms) {
    var root = cartEl();
    if (!root || !root.classList.contains('is-open')) return;
    // Une sortie déclenchée par un geste vif doit être PLUS COURTE que la
    // sortie par défaut : sinon le panneau semble freiner sous le doigt.
    // La duree de sortie est un REGLAGE : on la relit sur l element plutot
    // que de la figer dans une constante, sinon le minuteur de masquage se
    // desynchronise des que le marchand touche au curseur.
    // ATTENTION : Chrome NORMALISE les durees en secondes. Une variable
    // ecrite `400ms` est relue `.4s`. Un parseFloat seul donnerait 0,4 —
    // et le panneau serait masque au bout de 40 ms, sortie coupee net.
    // Il faut lire l unite, pas seulement le nombre.
    var brut = (getComputedStyle(root).getPropertyValue('--oz-cart-dur-out') || '').trim();
    var n = parseFloat(brut);
    var lue = isNaN(n) ? NaN : (/ms$/.test(brut) ? n : n * 1000);
    var sortie = isNaN(lue) ? CART_SLIDE_MS : lue + 40;
    var duree = typeof ms === 'number' ? ms : sortie;
    var pan = root.querySelector('.oz-cart__panel');
    if (pan) pan.style.transitionDuration = Math.max(0, duree - 30) + 'ms';
    root.style.setProperty('--oz-cart-progress', 0);
    root.classList.remove('is-open');
    // La hauteur figee NE SE RELACHE PAS ICI. La relacher au moment ou la
    // sortie demarre fait changer la taille du panneau pile a cet instant,
    // et comme il est ancre en bas, son bord HAUT saute. Pire :
    // `translateY(100%)` se mesure sur la hauteur de l element, donc la
    // distance a parcourir changeait en plein vol. On attend la fin.
    deverrouiller();
    document.body.style.paddingRight = '';
    document.documentElement.style.removeProperty('--oz-sb');
    clearTimeout(cartHideTimer);
    // on attend la fin du glissement avant de masquer : sinon la sortie
    // est coupée net et le panneau disparaît au lieu de sortir
    cartHideTimer = setTimeout(function () {
      root.style.visibility = '';
      if (pan) pan.style.transitionDuration = '';
      if (pan) pan.style.height = '';
      decaleTiroir();
    }, duree);
  }

  // Le contenu est rechargé via l'API de rendu de section : les prix restent
  // formatés par Liquid (devise, séparateurs, remises) au lieu d'être
  // reconstruits approximativement en JavaScript.
  function refreshCartDrawer() {
    var root = cartEl();
    if (!root) return Promise.resolve();
    return fetch(routeRoot() + '?sections=oz-glass-cart')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['oz-glass-cart'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-oz-cart-inner]');
        var current = root.querySelector('[data-oz-cart-inner]');
        if (!fresh || !current) return;
        // Remplacer un contenu identique relancerait pour rien l entree decalee
        // des articles : on verrait les lignes reapparaitre sans raison.
        if (fresh.innerHTML === current.innerHTML) return;
        current.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* le tiroir garde son contenu précédent */ });
  }

  function changeLine(line, quantity) {
    var root = cartEl();
    var panel = root && root.querySelector('.oz-cart__panel');
    if (panel) panel.setAttribute('aria-busy', 'true');
    return fetch(routeRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () { return Promise.all([refreshCartDrawer(), refreshCart()]); })
      .catch(function () {})
      .then(function () { if (panel) panel.removeAttribute('aria-busy'); });
  }

  // Le contenu ne doit PAS etre remplace pendant que le panneau monte : la
  // hauteur du tiroir changerait en cours de route, et `translateY(100%)`
  // vise une distance relative a cette hauteur. Le panneau sauterait.
  function apresEntree(fn) {
    var root = cartEl();
    var panel = root && root.querySelector('.oz-cart__panel');
    if (!panel) { fn(); return; }
    var fait = false;
    function finir() {
      if (fait) return;
      fait = true;
      panel.removeEventListener('transitionend', surFin);
      fn();
    }
    function surFin(e) {
      if (e.target === panel && e.propertyName === 'transform') finir();
    }
    panel.addEventListener('transitionend', surFin);
    // Repli indispensable : sans transition (mouvement reduit) ou dans un
    // onglet en arriere-plan, `transitionend` ne se declenche jamais.
    setTimeout(finir, 700);
  }

  function initCartDrawer() {
    var root = cartEl();
    if (!root || !once(root, 'ozCartDrawer')) return;

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-oz-cart-open]');
      if (opener) {
        e.preventDefault();
        openCart();
        apresEntree(function () {
          // La hauteur reprend sa liberte SEULEMENT une fois le panneau
          // pose : un ajustement a ce moment se lit comme une mise a jour
          // du contenu, pas comme une animation ratee.
          var pan = cartEl() && cartEl().querySelector('.oz-cart__panel');
          if (pan) pan.style.height = '';
          refreshCartDrawer();
        });
        return;
      }
      if (e.target.closest('[data-oz-cart-close]')) closeCart();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });

    // Quantité et retrait en DÉLÉGATION : le contenu du tiroir est remplacé
    // à chaque mise à jour, des écouteurs posés sur les boutons seraient
    // perdus au premier changement.
    root.addEventListener('click', function (e) {
      var item = e.target.closest('[data-oz-line]');
      if (!item) return;
      var line = parseInt(item.getAttribute('data-oz-line'), 10);
      if (isNaN(line)) return;

      if (e.target.closest('[data-oz-remove]')) {
        changeLine(line, 0);
        return;
      }
      var step = e.target.closest('[data-oz-qty]');
      if (step) {
        // Attribut explicite en priorite, `.mono` en repli : on ne depend pas
      // dune classe de presentation.
      var out = item.querySelector('[data-oz-qty-n]') || item.querySelector('.oz-cart__qty .mono');
        var n = parseInt(out ? out.textContent : '1', 10);
        if (isNaN(n)) n = 1;
        changeLine(line, Math.max(0, n + parseInt(step.getAttribute('data-oz-qty'), 10)));
      }
    });
  }



  /* ----------------------------------------------------------------
     Glisser pour fermer le panier

     Repris du tiroir Base UI, transposé en vanille :
       — le panneau suit le doigt au pixel près pendant le geste ;
       — le voile s'éclaircit à mesure qu'on tire ;
       — la sortie est d'autant plus courte que le geste était vif : elle
         PROLONGE le mouvement du doigt au lieu de le rattraper.
     ---------------------------------------------------------------- */
  function initCartSwipe() {
    var root = cartEl();
    if (!root || !once(root, 'ozCartSwipe')) return;
    var panel = root.querySelector('.oz-cart__panel');
    if (!panel || !window.PointerEvent) return;

    var actif = false, verrou = false, pid = null;
    var departX = 0, departY = 0, dernierX = 0, dernierT = 0, dx = 0, vitesse = 0;

    // Le sens de fermeture depend de la position du tiroir. `signe` vaut -1
    // quand le panneau sort dans le sens NEGATIF de son axe.
    var pos = root.getAttribute('data-oz-cart-pos') || 'left';
    var vertical = pos === 'bottom';
    var signe = (pos === 'right' || pos === 'bottom') ? 1 : -1;

    function taille() {
      var r = panel.getBoundingClientRect();
      return (vertical ? r.height : r.width) || 1;
    }
    function progres(p) { root.style.setProperty('--oz-cart-progress', p); }

    panel.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // Un geste qui commence sur une commande n'est pas un glissement.
      if (e.target.closest && e.target.closest('button, a, input, select, textarea')) return;
      actif = true; verrou = false; pid = e.pointerId;
      departX = e.clientX;
      departY = e.clientY;
      dernierX = vertical ? e.clientY : e.clientX;
      dernierT = e.timeStamp;
      dx = 0; vitesse = 0;
    });

    panel.addEventListener('pointermove', function (e) {
      if (!actif || e.pointerId !== pid) return;
      var ddx = e.clientX - departX;
      var ddy = e.clientY - departY;

      if (!verrou) {
        if (Math.abs(ddx) < 8 && Math.abs(ddy) < 8) return;
        // Verrou de direction : un geste vertical appartient au défilement
        // de la liste d'articles. On ne le lui vole pas.
        // Le geste perpendiculaire a laxe du tiroir appartient au
        // defilement de la liste : on ne le lui vole pas.
        var principal = vertical ? Math.abs(ddy) : Math.abs(ddx);
        var autre = vertical ? Math.abs(ddx) : Math.abs(ddy);
        if (autre > principal) { actif = false; return; }
        // Tiroir du bas : un geste vertical qui part de la liste et que la
        // liste peut encore absorber est un DEFILEMENT, pas une fermeture.
        // Sinon le panneau tirait de 18 % vers le haut avant que le
        // navigateur ne reprenne la main — un petit sursaut a chaque
        // defilement de la liste.
        if (vertical && zonePrend(zoneDefilante(e.target), ddy)) { actif = false; return; }
        verrou = true;
        root.classList.add('is-swiping');
        try { panel.setPointerCapture(pid); } catch (err) { /* sans importance */ }
      }

      // Vers la gauche le panneau RÉSISTE au lieu de sortir de l'écran :
      // le geste reste perceptible, mais il ne mène nulle part.
      // Le panneau est ancré A GAUCHE : on le ferme en tirant vers la gauche,
      // donc dx est NEGATIF. Vers la droite il resiste.
      var brut = vertical ? ddy : ddx;
      dx = (brut * signe >= 0) ? brut : brut * 0.18;

      var dt = Math.max(1, e.timeStamp - dernierT);
      var courant = vertical ? e.clientY : e.clientX;
      vitesse = (courant - dernierX) / dt; // px par milliseconde
      dernierX = courant;
      dernierT = e.timeStamp;

      panel.style.transform = (vertical ? 'translateY(' : 'translateX(') + dx + 'px)';
      progres(Math.max(0, Math.min(1, dx * signe / taille())));
    });

    function fin(e) {
      if (!actif || (pid !== null && e.pointerId !== pid)) return;
      var glissait = verrou;
      actif = false; verrou = false; pid = null;
      if (!glissait) return;

      root.classList.remove('is-swiping');
      panel.style.transform = '';

      // On ferme au-delà d'un tiers de la largeur, OU si le geste est vif :
      // un petit mouvement rapide doit fermer comme un grand mouvement lent.
      if (dx * signe > taille() * 0.33 || vitesse * signe > 0.5) {
        var reste = Math.max(0, 1 - dx * signe / taille());
        closeCart(Math.round(Math.max(160, CART_SLIDE_MS * reste)));
      } else {
        progres(0);
      }
    }

    panel.addEventListener('pointerup', fin);
    panel.addEventListener('pointercancel', fin);
  }

  function init(root) {
    initStickyHeader();
    initCartDrawer();
    initCartSwipe();
    initMarquees(root);
    initGrow(root);
    initGallery(root);
    initQty(root);
    initVariants(root);
    initQuickAdd(root);
    initAtcForms(root);
    initNav(root);
    initAcc(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // L'éditeur de thème recharge les sections à chaud.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
